import { EmailChangePendingStatus, TError } from '@onesource/schemas';
import { useQuery } from '@tanstack/react-query';

import axios from '../../common/axios';
import { ENTITY } from './entity';

export const getEmailChangePendingQueryKey = () => [ENTITY, 'email-change', 'pending'];

/**
 * Polls the pending email-change status. Powers the "verification link sent"
 * banner on the account page. Kept fresh on a short interval so the banner
 * clears soon after the user confirms via the link in another tab/device.
 */
export const useEmailChangePendingQuery = (enabled = true) => {
  return useQuery<EmailChangePendingStatus, TError>({
    queryKey: getEmailChangePendingQueryKey(),
    queryFn: async () => {
      const { data } = await axios.get<EmailChangePendingStatus>(`${ENTITY}/email-change/pending`);
      return data;
    },
    enabled,
    staleTime: 30 * 1000,
    refetchInterval: 60 * 1000,
  });
};
